import { DigitalPassport } from "@/types/battle"
import { webNavigate } from "@/navigation/webNavigate"
import { hasSelectedLeague, needsAffiliationSelection } from "@/utils/onboardingPassport"
import { isAffiliationRequiredError } from "@/api/gameApiErrors"

export function ensureAffiliationForPvp(
  passport: DigitalPassport | null | undefined,
  navigate?: (path: string) => void
): passport is DigitalPassport {
  if (!passport) return false
  if (!needsAffiliationSelection(passport)) return true
  const go = navigate ?? webNavigate
  go("/play/onboarding/affiliation")
  return false
}

export function handleAffiliationPvpError(
  message: string,
  navigate?: (path: string) => void
): boolean {
  if (!isAffiliationRequiredError(message)) return false
  const go = navigate ?? webNavigate
  go("/play/onboarding/affiliation")
  return true
}

export function inferNeedsAffiliationFromPassport(
  passport: DigitalPassport
): boolean {
  if (passport.needsAffiliationSelection) return true
  if (passport.affiliationElement) return false
  return hasSelectedLeague(passport)
}
